<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="serial-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-sort-numeric-down"></i>
                        タイトル編集
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="list-group">
                        <li class="list-group-item" v-for="v in episodes" :key="v.id"
                            :class="{'b-air': v.is_chapter}">
                            <div v-if="v.org !== v.section_name"
                                v-html="$filters.ruby(v.org)"
                                class="deleted small mx-2"></div>
                            <div class="mx-2" v-if="v.org !== v.section_name">↓</div>
                            <input type="text" class="form-control form-control-sm"
                                :class="{'font-weight-bold': v.is_chapter}" v-model="v.section_name">
                        </li>
                    </ul>
                    <div class="m-3">
                        本文タイトルを一括変更します。<br>
                        タイトルのナンバリングにズレがあれば、自動で正規化します。<br>
                        必ずしも自動ナンバリングが正しいとは限らないため、目視確認をお願いします。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" :disabled="noSort" @click="sort()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.deleted {
    text-decoration: line-through;
    color: #aaa;
}
</style>

<script>
export default {
    props: [
        "book_id"
    ],
    data() {
        return {
            episodes: [],
        }
    },
    methods: {
        load() {
            axios.post("/mypage/book/sections/sort/try", {book_id: this.book_id}).then(res => {
                this.episodes = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        sort() {
            axios.post("/mypage/book/sections/sort/save", {
                book_id: this.book_id,
                episodes: this.episodes
            }).then(res => {
                alert.msg(res.data);
                $("#serial-modal").modal("hide");
                this.$emit("saved");
            }).catch(err => { alert.err(err.response) });
        },
        title(v) {
            if (v.org == v.section_name) {
                return this.$filters.ruby(v.section_name);
            } else {
                return this.$filters.ruby(v.org +"→"+ v.section_name);
            }
        }
    },
    computed: {
        noSort() {
            if (_.find(this.episodes, (o) => { return o.org !== o.section_name; })) {
                return false;
            }
            return true;
        }
    },
    mounted() {
        $("#serial-modal").on("show.bs.modal", (e) => {
            this.load();
        });
    }
}
</script>